"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DonateButton = void 0;

var _reactCopyToClipboard = _interopRequireDefault(require("react-copy-to-clipboard"));

var _atoms = require("../atoms");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var DonateButton = function DonateButton(_ref) {
  var icon = _ref.icon,
      address = _ref.address,
      onCopy = _ref.onCopy,
      children = _ref.children;
  return (0, _jsxRuntime.jsx)(_reactCopyToClipboard["default"], {
    text: address,
    onCopy: onCopy,
    children: (0, _jsxRuntime.jsx)(_atoms.Button, {
      backgroundColor: "footer.donate",
      variant: "donation",
      width: "auto",
      mt: {
        _: '15px',
        lg: '0'
      },
      mr: {
        _: '0',
        lg: '15px'
      },
      children: (0, _jsxRuntime.jsxs)(_atoms.Flex, {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        children: [(0, _jsxRuntime.jsx)(_atoms.Icon, {
          type: icon,
          height: "15px",
          mr: "10px",
          verticalAlign: "middle"
        }), (0, _jsxRuntime.jsx)(_atoms.Body, {
          color: "text.footer",
          fontSize: "14px",
          children: children
        })]
      })
    })
  });
};

exports.DonateButton = DonateButton;